import {motion} from "framer-motion";
import {FaGraduationCap} from "react-icons/fa";
import CustomCursor from "../components/CustomCursor";

const educationData=[
    {
        university: "APJ Abdul Kalam Technological University",
        institution: "Khoury College Of Computer Science, Northeastern University",
        degree: "MSCS (Masters in Computer Science)",
        duration: "2025 - Current",
        location: "Boston, Masachusetts - USA",
        cgpa: "3.8 / 4 CGPA",
        highlights:[
           
        ]
    },
    {
        institution: "Viswajyothi College of Engineering and Technology",
        degree: "B.Tech (Bachelor Of Technology) - Computer Science",
        duration: "2018 - 2022",
        location: "Kerala, India",
        cgpa: "8.82 / 10 CGPA",
        highlights:[
            "Relevant coursework: Data Structures, System Software, Computer Networks, Computer System Architecture, Distributed Computing, Web Technology",
            "Built a strong foundation in core CS areas including systems-level programming, and web development",
            "Explored system internals through hands-on work in System Software and Computer Architecture labs",
            "Was awarded a Merit-based scholarship for academic perfomance",
            "Presented paper on AI-based Wheelchair Navigation",
            "Graduated among top 5% of class"
        ]
    },
];

export default function Education(){
    return (
      <>
      <CustomCursor/>
        <main className="min-h-screen bg-animated-gradient text-white px-6 py-16">
        <motion.h1
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-4xl font-bold px-6 py-9 text-center  text-purple-400"
      >
        Education
      </motion.h1>
       <div className="max-w-4xl mx-auto space-y-10">
        {educationData.map((edu, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: idx * 0.2 }}
            className="bg-[#161b22] p-6 rounded-lg shadow-lg border-l-4 border-purple-500"
          >
            <div className="flex items-center space-x-4 mb-2">
              <FaGraduationCap className="text-purple-400 text-2xl" />
              <h2 className="text-xl font-semibold">{edu.institution}</h2>
            </div>
            <p className="text-purple-300 text-md font-medium mb-1">
              {edu.degree}
            </p>
            <p className="text-gray-400 text-sm mb-2">
              {edu.duration} — {edu.location}
            </p>
            <p className="text-sm text-blue-300 mb-2">
              <span className="font-semibold">CGPA:</span> {edu.cgpa}
            </p>
            <ul className="list-disc list-inside text-sm text-gray-300 space-y-1">
              {edu.highlights.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
        </main>
      </>
    );
}